import React from 'react'
import AnnouncementContainer from '@/src/components/announcements'

const Announcements = () => {
  return <AnnouncementContainer category="announcement" />
}

export default Announcements
